// extracted by mini-css-extract-plugin
module.exports = {"winnerItem":"_de337be","reversed":"_5676f1c","details":"_88688b1","username":"_3cf00f7","award":"_8e2b994","paidPlaces":"_c99540a","label":"_6d288aa","value":"_eaea967"};